export const SHOW_WILLITEM_MODAL = 'SHOW_WILLITEM_MODAL'
export const HIDE_WILLITEM_MODAL = 'HIDE_WILLITEM_MODAL'
export const FILL_MODAL_DETAILS = 'FILL_MODAL_DETAILS'
export const FILL_MODAL_RELATIVES = 'FILL_MODAL_RELATIVES'
export const SHOW_ADDMEMBER_MODAL = 'SHOW_ADDMEMBER_MODAL'
export const HIDE_ADDMEMBER_MODAL = 'HIDE_ADDMEMBER_MODAL'
export const WILL_LIST_DATA ='WILL_LIST_DATA'
